import axios from "axios";
export default {
  state: {
  },

  getters: {},

  mutations: {
  },

  actions: {
    async tresultFetchDiscipLines({ commit, getters, dispatch, state }, path) {
      return await axios.get(path).then(res=>res)
    },
  },
};
